import { oneOfType, node, arrayOf, string, object, bool } from 'prop-types'

const Link = ({
  children,
  cssClass = '',
  link = '',
  title = '',
  text = '',
  otherProps = {},
  role = '',
  ariaLabel,
  ariaExpanded,
  dataTarget,
  target = '_self'
}) => {
  return (
    <a
      href={link}
      title={title}
      className={cssClass}
      role={role}
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
      target={target}
      data-target={dataTarget}
      {...otherProps}
    >
      {text || children}
    </a>
  )
}

Link.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
  cssClass: string,
  otherProps: object,
  role: string,
  ariaLabel: string,
  ariaExpanded: bool,
  dataTarget: string,
  link: string,
  title: string,
  text: string,
  target: string
}

export default Link
